export default __webpack_public_path__ + "static/media/diet.5b125630.svg";